/**
 * Configuración central de CTAs. Fuente única de los destinos de conversión:
 * cambiar aquí propaga a Navbar, Hero, secciones CTA y footer.
 */

import { company } from './company';

// CTA principal: lleva al formulario de contacto.
export const primaryCTA = {
  label: 'Agendar una consulta',
  href: '/contacto/',
  gtmEvent: 'contact_request',
};

// CTA secundario: recorrido por los servicios.
export const secondaryCTA = {
  label: 'Nuestros servicios',
  href: '/servicios/',
};

// Canal directo por WhatsApp.
export const whatsappCTA = {
  label: 'WhatsApp',
  href: company.whatsapp,
  external: true,
  gtmEvent: 'whatsapp_click',
};
